import React from 'react';

export function useFullscreen() {
  const [fullscreen, setFullscreen] = React.useState<boolean>(false);

  const handleEnterFullscreen = React.useCallback<VoidFunction>(() => {
    setFullscreen(true);
  }, []);

  const handleExitFullscreen = React.useCallback<VoidFunction>(() => {
    setFullscreen(false);
  }, []);

  return React.useMemo(
    () => ({
      onEnterFullscreen: handleEnterFullscreen,
      onExitFullscreen: handleExitFullscreen,
      showEnterFullscreen: !fullscreen,
      showExitFullscreen: fullscreen,
    }),
    [fullscreen, handleEnterFullscreen, handleExitFullscreen],
  );
}
